<template>
  <pop-box ref="myPopbox" class="upload-popbox" :hasNotButton="true" :title="title" @closeDialog="$emit('close')"
           :width="750">
    <el-form ref="form" :model="formData" label-width="100px">
      <el-form-item label="菜单名称">
        <el-input v-model="formData.menuName"></el-input>
      </el-form-item>
      <el-form-item label="图标">
        <el-input v-model="formData.icon"></el-input>
      </el-form-item>
      <el-form-item label="url">
        <el-input v-model="formData.url"></el-input>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-switch
          style="margin-left: 8px;"
          v-model="formData.isStart"
          active-value="1"
          inactive-value="2"
          active-text="是"
          inactive-text="否">
        </el-switch>
      </el-form-item>
    </el-form>
    <div class="dialog-footer btn-wrapper">
      <el-button class="btnx-normal btn-blue" @click="onSureSave">保存</el-button>
      <el-button class="btnx-normal btn-gray" @click="onClose">关闭</el-button>
    </div>
  </pop-box>
</template>
<script>
  import {getAction} from "@/service/http/api";
  import des from '@/service/des'
  import editMixin from "@/mixin/editModal"
  export default {
    name: 'Edit',
    props: ['rowId','title','mode','config'],
    mixins:[editMixin],
    data() {
      return {
        formData:{
          id:null,
          menuName:null,
          icon:null,
          parentId:null,
          isStart:"1",
          sortNo:1,
          url:null
        },
        url:{
          add:'/permission/add',
          edit:'/permission/edit',
          query:'/permission/queryById'
        }
      }
    },
    methods: {
      onSureSave(){
        this.formData.id=this.rowId;
        this.formData.parentId=this.config.parentId;
        this.formData.sortNo=this.config.sortNo;
        this.onSave();
      }
    }
  }
</script>

<style lang="scss" scoped>
  .img-item{
    margin: 20px 40px;
    float: left;
    position: relative;
    width: 300px;
    p{
      line-height: 30px;
      color: #0D74FE;
    }
    .left,.right{
      position: absolute;
      top: 0;
      width: 30px;
      height: 300px;
      background: #FFFFFF;
    }
    .left{
      left: 0;
    }
    .right{
      right: 0;
    }
  }
  .img-item img{
    width: 240px;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/permession_management/edit.vue